import React from 'react';
import { Typography, Space } from 'antd';

const { Text } = Typography;

const AnswersList = ({
    question,
    answers,
    pagePos,
    isAnswer
}) => {
    return (
        <Space direction="vertical" size="large" style={{ width: '100%', marginTop: 20 }}>
            {/* Mostrar la pregunta */}
            {
                (pagePos == 0 && isAnswer) && <Text>{question}</Text>
            }
            <ul>
                {
                    answers.map((answer, index) => {
                        return <li key={index} style={{ marginBottom: '8px', fontSize: '11px' }}>{answer}</li>;
                    })
                }
            </ul>
        </Space>
    );
};

export default AnswersList;
